export default __webpack_public_path__ + "static/precog-white-wordmark-4d3e41ca105ae4765414d657c379e384.png";